import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import styles from "./styles/Transaction.module.css"
import TableFilter from "./TableFilter";
import TableFooter from "./TableFooter";
import { TransactionTable } from "./TransactionTable";
import config from '../../../config'
import { formatDate } from "../../../Utils/formatDate";

const base_url=config.base_url
function Transaction() {
  const [data, setData]=useState([])
  const [filter, setFilter] = useState({
    "filter_value":"",
    "filter_field":"user_id",
    "max_date":Date.now(),
    "min_date":new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 7).getTime(),
    "sort":"",
    "nlogs":"20",
    "page":1,
  })
  const [maxPages, setmaxPages] = useState(1)
  const RequestData = (filter) =>{
    fetch(base_url+'admin/transactionLogs',{
      method: 'POST',
      mode: 'cors',
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-type': 'application/x-www-form-urlencoded',
          'credentials':'include'
      },
      body: `filter_value=${filter.filter_value}&filter_field=${filter.filter_field}&max_date=${filter.max_date}&min_date=${filter.min_date}&nlogs=${filter.nlogs}&page=${filter.page}&sort=${filter.sort}`,
      credentials:'include'
    }).then(res=>res.json())
    .then((data)=>{
      if (data.error)return
      else{

        if (data.result.total===0) setmaxPages(1)
        else setmaxPages(Math.ceil(data.result.total/filter.nlogs))
        setData(data.result.data)

      }
    })
  }
  const DownloadCSV = (filter) =>{
    fetch(base_url+'admin/transactionLogs/download',{
      method: 'POST',
      mode: 'cors',
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-type': 'application/x-www-form-urlencoded',
          'credentials':'include'
      },
      body: `filter_value=${filter.filter_value}&max_date=${filter.max_date}&min_date=${filter.min_date}`,
      credentials:'include'
    })
    .then(res=>res.blob())
    .then((blob)=>{
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'EventLogs.csv');
      document.body.appendChild(link);
      link.click();
    })
  }
  useEffect(() => {
    console.log(filter)
    RequestData(filter)
  }, [filter]);
  useEffect(()=>{
    handleChange(1, "page")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxPages])
  const columns = useMemo(()=>[
    {
        Header: "User ID",
        accessor: "user_id",
        disableSortBy: true,
        Cell:({row, value})=>{
          return (<span>{value}</span>)
        }
    },
    {
        Header: "Date",
        accessor: "date",
        disableSortBy: true,
        Cell:({row, value})=>{
          return (<span>{formatDate(value*1000).split(' ')[0]}</span>)
        }
    },
    {
      Header: "Time",
      disableSortBy: true,
      Cell:({row, value})=>{
        return (<span>{formatDate(row.values.date*1000).split(' ')[1]}</span>)
      }
    },
    {
      Header: "Reason",
      accessor: "reason",
      disableSortBy: true,
      Cell:({row, value})=>{
        return (<span>{value}</span>)
      }
    },
    {
      Header: "Amount Chaged",
      accessor: "amount",
      disableSortBy: true,
      Cell:({row, value})=>{
        return (<span>{value/100 +"$"}</span>)
      }
    },
    {
      Header: "Transaction Responsible",
      accessor: "responsible",
      disableSortBy: true,
      Cell:({row, value})=>{
        return (<span>{value}</span>)
      }
    },
    {
        Header: "Comment",
        accessor: "comment",
        disableSortBy: true,
        Cell:({row, value})=>{
          return (<span>{value}</span>)
        }
    },
    {
      Header: "Invoice",
      accessor: "invoice_number",
      disableSortBy: true,
      Cell:({row, value})=>{
        const invoice_link = data.map(e=>{
          if (e.invoice_number===value) return e.invoice_link
          return null
        }).filter(e=>e!==undefined)
        const invoice_link_=invoice_link[0]
        console.log(invoice_link_)
        return (<a href={invoice_link_} target={invoice_link_} ><span>{value}</span></a>)
      }
    },
    {
      Header: "Status",
      accessor: "status",
      disableSortBy: true,
      Cell:({row, value})=>{
        return (<span>{value}</span>)
      }
    },
    {
      Header: "Sending Date",
      accessor: "sending_dates",
      disableSortBy: true,
      Cell:({row, value})=>{
        return (<span>{formatDate(value*1000)}</span>)
      }
    },
    {
        Header: "Email Address",
        accessor: "email",
        disableSortBy: true,
        Cell: ({row,value})=>{
          return (<span>{value}</span>)
        }
    }], [data]);
  const handleChange = (value, field) =>{
    console.log(`${value},${field}`)
    setFilter({...filter,[field]:value})
  }

  return (
    <div className={styles.main_box}>
        <h1>Transactions</h1>
        <div className={styles.table_div}>
          <TableFilter filter={filter} setFilter={setFilter} handleChange={handleChange} DownloadCSV={DownloadCSV}/>
          <TransactionTable columns={columns} data={data} filter={filter} setFilter={setFilter} handleChange={handleChange}/>
          <TableFooter filter={filter} setFilter={setFilter} maxPages={maxPages} handleChange={handleChange}/>
        </div>
    </div>    
  );
}

export default Transaction;
